import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

import type { Project } from '../../aansluiting/project/types/Project'
import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { useDebounce } from '../../core/hooks/useDebounce'
import type { HoofdleidingProject } from '../../hoofdleiding/project/types/HoofdleidingProject'
import { fetchSearchBar } from '../services/fetchSearchBar'

const queryKey = 'searchbar'

const initialState: (Project | HoofdleidingProject)[] = []

export const useSearchbar = () => {
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search)

  const { hasPermissions } = useAuthenticatedUser()

  const { data, isFetching: isLoading } = useQuery({
    queryKey: [queryKey, debouncedSearch],
    queryFn: () => {
      return fetchSearchBar({ id: debouncedSearch })
    },
    enabled: hasPermissions && !!debouncedSearch,
  })

  return {
    data: data || initialState,
    search,
    setSearch,
    isLoading,
  }
}
